import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 华夏
  {
    path: '/',
    redirect: '/hxauth'
  },
  {
    path: '/hxauth',
    name: 'HxAuth',
    meta: { title: '授权' },
    component: () => import('@/views/hx/auth.vue')
  },
  {
    path: '/hxlogin',
    name: 'HxLogin',
    meta: { title: '登录' },
    component: () => import('@/views/hx/login.vue')
  },
  {
    path: '/hxpay',
    name: 'HxPay',
    meta: { title: '支付' },
    component: () => import('@/views/hx/pay.vue')
  },
  {
    path: '/hxlist',
    name: 'HxList',
    meta: { title: '订单列表' },
    component: () => import('@/views/hx/order.vue')
  },
  // 华夏生成三个测试链接与原本界面分离
  {
    path: '/anthor/hxauth',
    name: 'HxAuthTest',
    meta: { title: '授权' },
    component: () => import('@/views/hx/test/auth.vue')
  },
  {
    path: '/test/hxlogin',
    name: 'HxLoginTest',
    meta: { title: '登录' },
    component: () => import('@/views/hx/test/login.vue')
  },
  {
    path: '/test/hxpay',
    name: 'HxPayTest',
    meta: { title: '支付' },
    component: () => import('@/views/hx/test/pay.vue')
  },
  {
    path: '/test/hxlist',
    name: 'HxListTest',
    meta: { title: '订单列表' },
    component: () => import('@/views/hx/test/order.vue')
  },
  // 美团M站
  {
    path: '/mtpay',
    name: 'MtPay',
    meta: { title: '美团M站收银台' },
    component: () => import('@/views/mt/pay.vue')
  },
  {
    path: '/mtResult',
    name: 'MtResult',
    meta: { title: '美团M站收银台' },
    component: () => import('@/views/mt/result.vue')
  },
  // 华夏静态界面
  {
    path: '/hxstatic',
    name: 'HxStatic',
    meta: { title: '信用卡新户活动' },
    component: () => import('@/views/hxStatic/index.vue')
  },
  {
    path: '/removeCard',
    name: 'RemoveCard',
    meta: { title: '信用卡新户活动' },
    component: () => import('@/views/hxStatic/removeCard.vue')
  },
  {
    path: '/hxrule',
    name: 'HxRule',
    meta: { title: '活动细则' },
    component: () => import('@/views/hxStatic/rule.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
